import { TooltipStyled } from 'components/Tooltip/TooltipStyles';
import React from 'react';
import { Position, Tooltip as TippyTooltip, Trigger } from 'react-tippy';

export type TooltipProps = {
  placement?: Position;
  trigger?: Trigger;
  message: string;
  variant?: TooltipVariant;
  disabled?: boolean;
  followCursor?: boolean;
  delay?: number;
  hideTooltip?: boolean;
  style?: any;
  children: any;
};

export enum TooltipVariant {
  dark = 'dark',
  light = 'light',
}
const Tooltip: React.FC<TooltipProps> = ({
  variant = TooltipVariant.dark,
  placement = 'bottom',
  trigger = 'mouseenter',
  disabled = false,
  message,
  children,
  followCursor = true,
  delay,
  style,
}) => {
  if (!message) return children;

  return (
    <TippyTooltip
      // options
      disabled={disabled}
      html={<TooltipStyled>{message}</TooltipStyled>}
      position={placement}
      trigger={trigger}
      animateFill={false}
      followCursor={followCursor}
      theme={variant}
      delay={delay ?? 0}
      style={style}
    >
      {children}
    </TippyTooltip>
  );
};

export default Tooltip;
